import { ActionButton, Icon } from "@fluentui/react";
import { useFormikContext } from "formik";
import React from "react";
import { useTranslation } from "react-i18next";
import { useCurrentRoute } from "../../../config/routes";
import { useSelector } from "../../../store/hooks";
import {
  selectCanNotifyAdd,
  selectCanNotifyEdit,
} from "../../../store/recommendationPage";

type Props = {
  setDidTrySubmit: () => void;
};

export const SaveRecomendationButton = ({ setDidTrySubmit }: Props) => {
  const { t } = useTranslation();

  const { submitForm, setFieldValue } = useFormikContext();

  const route = useCurrentRoute();

  const isEdit = route === "editRecommendation";
  const isSaveRecLoading = useSelector(
    (s) => s.recommendationPage.isSaveLoading,
  );
  const isRecLoading = useSelector((s) => s.recommendationPage.isRecLoading);
  const canNotifyEdit = useSelector(selectCanNotifyEdit as any);
  const canNotifyAdd = useSelector(selectCanNotifyAdd as any);
  const isLoading = isSaveRecLoading || isRecLoading;
  const isDisabled = isLoading || isRecLoading;

  let canNotify;

  if (isEdit) {
    canNotify = canNotifyEdit;
  }
  //
  else {
    canNotify = canNotifyAdd;
  }

  return (
    <div style={{ display: "flex", gap: "8px" }}>
      <ActionButton
        onClick={() => {
          setFieldValue("mode", "normal");
          setDidTrySubmit();
          submitForm();
        }}
        disabled={isDisabled}
      >
        <Icon iconName="Save" style={{ marginRight: 4 }} />
        {t("greco.save")}
      </ActionButton>
      <ActionButton
        onClick={() => {
          setFieldValue("mode", "notify");
          setDidTrySubmit();
          submitForm();
        }}
        disabled={isDisabled || !canNotify.result}
      >
        <Icon
          iconName={canNotify.isLoading ? "ProgressRingDots" : "Ringer"}
          style={{ marginRight: 4 }}
        />
        {t("ram.navBar.saveAndNotify")}
      </ActionButton>
      <ActionButton
        onClick={() => {
          setFieldValue("mode", "addNew");
          setDidTrySubmit();
          submitForm();
        }}
        disabled={isDisabled}
      >
        <Icon iconName="Add" style={{ marginRight: 4 }} />
        {t("ram.navBar.saveAndNew")}
      </ActionButton>
    </div>
  );
};
